import React from "react";
import {
  REASONING_EFFORT_LABELS,
  allowedReasoningEfforts,
  getReasoningProfile,
  reasoningLatencyHint,
} from "./llmReasoningOptions";

// Thinking toggle + effort level for models with reasoning controls (Sonnet 5.5, Haiku 5.5,
// Grok 4.7). Renders nothing for any other model. The parent form keeps the selection valid
// for the current model via normalizeReasoningSelection.
export const LlmReasoningControls = ({
  idPrefix,
  model,
  thinkingEnabled,
  onThinkingChange,
  reasoningEffort,
  onEffortChange,
}) => {
  const profile = getReasoningProfile(model);
  if (!profile) return null;

  const efforts = allowedReasoningEfforts(model, thinkingEnabled);
  const hint = reasoningLatencyHint(model, thinkingEnabled, reasoningEffort);
  const helpStyle = { fontSize: "0.8rem", lineHeight: 1.6 };

  return (
    <div className="mb-3">
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`${idPrefix}ThinkingEnabled`}
          checked={profile.canDisableThinking ? thinkingEnabled : true}
          disabled={!profile.canDisableThinking}
          onChange={(e) => onThinkingChange(e.target.checked)}
        />
        <label className="form-check-label text-white" htmlFor={`${idPrefix}ThinkingEnabled`}>
          Thinking
        </label>
      </div>
      {!profile.canDisableThinking && (
        <p className="text-white-50 mb-0 mt-1" style={helpStyle}>
          {profile.label} always reasons; only its effort level can be changed.
        </p>
      )}

      <label className="text-white form-label mt-2" htmlFor={`${idPrefix}ReasoningEffort`}>
        Effort level
      </label>
      <select
        className="bg-black border-0 text-white py-2 px-3 form-select"
        id={`${idPrefix}ReasoningEffort`}
        value={reasoningEffort}
        onChange={(e) => onEffortChange(e.target.value)}
      >
        {efforts.map((effort) => (
          <option className="selectedProviderOption" key={effort} value={effort}>
            {REASONING_EFFORT_LABELS[effort]}
          </option>
        ))}
      </select>
      <p className="text-white-50 mb-0 mt-2" style={helpStyle}>
        {profile.canDisableThinking && !thinkingEnabled
          ? "With thinking off, effort tops out at High. Turn thinking on for Extra high and Max."
          : "Higher effort reasons more before answering, which adds latency."}
      </p>
      {hint && (
        <p className="mb-0 mt-1" style={{ ...helpStyle, color: "#f0ad4e" }}>
          {hint}
        </p>
      )}
    </div>
  );
};
